import Vue from '@/setup'

import {LogHelper, ProductHelper} from '@/helpers'
import { EVENT_PRODUCT_STRUCTURE_SET } from '@/config/events'

export default {
  namespaced: true,

  state () {
    return {
      categories: {},
      groups: {},
      products: {}
    }
  },

  getters: {

    getCategories: state => ProductHelper.getSortedCategories(state.categories),

    getCategoryFromProduct: (state, getters) => productId => state.categories[getters.getCategoryIdFromProduct(productId)],

    getCategoryIdFromProduct: state => productId => ProductHelper.getCategoryIdFromProduct(state, productId),

    getGroupFromProduct: (state, getters) => productId => state.groups[getters.getGroupIdFromProduct(productId)],

    getGroupIdFromProduct: state => productId => ProductHelper.getGroupIdFromProduct(state.groups, productId),

    getGroupsFromCategory: state => categoryId => ProductHelper.getSortedGroupsFromCategory(state.categories, state.groups, categoryId),

    getProductsFromCategory: state => categoryId => ProductHelper.getSortedProductsFromCategory(state, categoryId),

    getProductsFromGroup: state => groupId => ProductHelper.getSortedProductsFromGroup(state.groups, state.products, groupId),

    getProducts: state => state.products,

    getSelectedProductsByCategory: state => products => ProductHelper.getSelectedProductsByCategory(state, products),
  },

  mutations: {
    /**
     * overwrite the product-structure (categories, groups, products)
     * @param {Object} state
     * @param {[type]} data  payload with all categories, groups and products
     */
    SET_PRODUCT_STRUCTURE (state, data) {
      Object.keys(data).forEach(key => {
        Vue.set(state, key, data[key])
      })
      LogHelper.info(['%cSET_PRODUCT_STRUCTURE', 'color: lightgreen', data])
    }
  },

  actions: {

    /**
     * set (/overwrite) the whole product structure
     * @param {Object} options.state
     * @param {fn} options.commit
     * @param {Object} data
     */
    setProductStructure ({ commit }, data) {
      return new Promise(resolve => {
        commit('SET_PRODUCT_STRUCTURE', data)
        this._vm.$EventBus.$emit(EVENT_PRODUCT_STRUCTURE_SET, data)
        resolve(data)
      })
    }
  }
}
